import axios from 'axios'
import Swal from 'sweetalert2'


async function uploadImage(upload) {
    var FormData = require('form-data');
    var data = new FormData();
    data.append('file', upload);

    var config = {
        method: 'post',
        url: `${process.env.REACT_APP_API}/participant/payment/upload`,
        data: data
    };

    const res = await axios(config);
    return res
}

export default async function onSubmitPayment(fullname, email, date, sendBank, transferAmount, fromBank, accNumber, upload, Desc, history, paymentId, accNumberName) {
    let image = await uploadImage(upload)
    axios.post(`${process.env.REACT_APP_API}/participant/payment/confirm`, {
        payment_id: paymentId,
        bank_account_id: 1,
        transfer_amount: transferAmount.split('.').join(""),
        transfer_date: date,
        transfer_bank_id: fromBank.id,
        transfer_bank_name: fromBank.name,
        transfer_bank_account: accNumber,
        transfer_bank_holder_name: accNumberName,
        transfer_attachment: image.data,
        note: Desc
    })
        .then(function (response) {
            history.push({
                pathname: '/payment/confirm/success',
                state: { name: fullname.split(" ", 1)[0] }
            })
        })
        .catch(function (error) {
            Swal.hideLoading()
            return Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: error
            })
        })
    // axios.post(`${process.env.REACT_APP_API}/participant/payment/confirm/count`, {
    //     payment_id: paymentId
    // })
    //     .then(async (response) => {
    //         console.log('ini response', response)
    //         if (response.data.countParticipantPayment === 0) {
    //         } else {
    //             return Swal.fire({
    //                 icon: 'error',
    //                 title: 'Oops...',
    //                 text: `Kamu sudah melakukan konfirmasi pembayaran`
    //             })
    //         }
    //     })
    //     .catch((err) => {
    //         console.log(err)
    //     })
}